export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS';
export const FETCH_COUNTRY_REQUEST = 'FETCH_COUNTRY_REQUEST';
export const FETCH_COUNTRY_FAILURE = 'FETCH_COUNTRY_FAILURE';
export const fetchCountrySuccess = (payload) => ({
    type: FETCH_COUNTRY_SUCCESS,
    payload,
});
export const fetchCountryRequest = () => ({
    type: FETCH_COUNTRY_REQUEST,
});
export const fetchCountryFailure = (payload) => ({
    type: FETCH_COUNTRY_FAILURE,
    payload,
});
